module.exports = __webpack_public_path__ + "assets/img/logo_acoucou_white.svg";